module.exports = __FOREMAN_VENDOR__SPICE_PROJECT_SPICE_HTML_5__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__SPICE_PROJECT_SPICE_HTML_5__"
// module id = @spice-project/spice-html5
// module chunks = 32